
import { SettingsMainContainer, TopHeaderSettings } from './settings.styled'
import { useSelector } from 'react-redux'
import Loader from "loaders/Loader";
import ReqSentItem from './requests/ReqSentItem' 
import { RiGroupLine } from 'react-icons/ri';

import { useTranslation } from 'react-i18next'

function RequestsSent() {
  const { t: translate } = useTranslation()
    const { requestsSent, isRequestGetSuccess, isRequestGetLoading, isRequestGetError, requestGetmessage } = useSelector((state) => state.requests)
    const { user } = useSelector((state) => state.auth)

    return (
        <SettingsMainContainer>
            <TopHeaderSettings>
                    {
                        translate("web:settings.requestsSent")
                    }
            </TopHeaderSettings> 
            { isRequestGetLoading ? 
                (
                    <Loader />
                )
                : isRequestGetSuccess && !isRequestGetLoading && requestsSent.length > 0 ?
                ( 
                  requestsSent.map( ele => (
                        <ReqSentItem 
                            key={ele._id} 
                            churchId={ele.receiverId._id} 
                            reqId={ele._id}
                            fullName={ele.receiverId.fullName}
                            username={ele.receiverId.username}
                            image={ele.receiverId.profileImg.url} 
                        />
                    )) 
                )
                :
                (
                    <div className='noRequestsWrap'>
                        <div> <RiGroupLine className="noRequestsIcon" /></div>
                        <div className='noRequests'>
                            {
                                translate("web:settings.noRequests")
                            }
                        </div>
                    </div> 
                )}
        </SettingsMainContainer>
    )
}

export default RequestsSent 
